export const en = {
  "state.unavailableBody": "This checkout is temporarily unavailable. Please try again later.",
  "action.accessExpired": "This access has expired or is no longer available. Request a new link to continue.",
  "action.requestLink": "Send new link",
  "action.linkSent": "If this access is valid, we will send a new link to the registered email.",
  "action.accessProcessing": "The payment may still be processing. Request a new link to check its status. Do not pay again.",

  "payment.refundRequested": "Refund requested",
  "payment.partiallyRefunded": "Partially refunded",
  "payment.refunded": "Refunded",
  "payment.disputed": "Payment disputed",
  "payment.updatedCharges": "Current payment status",

  "error.priceChangedTitle": "Outdated details",
  "block.PRECO_ALTERADO": "The details of this purchase are out of date. Refresh the page and review the price before continuing.",
  "error.refresh": "Refresh page",
  "error.priceRefreshed": "We refreshed the exchange rate. Review the price and confirm again to continue.",
  "summary.loading": "Loading order summary",
  "summary.unavailableTitle": "Order summary unavailable",
  "summary.unavailableBody": "We could not load the details. Check your purchase confirmation email.",
  "summary.mainPurchase": "Main purchase",
  "summary.additionalOffer": "Additional offer",
  "upsell.protectedOffer": "Protected offer",
  "upsell.storageTitle": "Confirm to view your offer",
  "upsell.storageDeniedTitle": "Offer unavailable in this browser",
  "upsell.storageBody": "Your browser protects data across sites. Allow VendePay to load this offer securely.",
  "upsell.storageDeniedBody": "Your browser did not allow access on this site. Open the offer securely on VendePay or continue without it.",
  "upsell.loading": "Loading…",
  "upsell.loadOffer": "Load offer",
  "upsell.openHosted": "Open offer on VendePay",
  "action.processingTitle": "Payment processing",
  "action.canceledTitle": "Cancellation requested",
  "action.alreadyCanceledTitle": "Subscription already canceled",
  "action.cardUpdatedTitle": "Card updated",
  "action.paidTitle": "Payment processed",
  "action.cancelTitle": "Cancel subscription",
  "action.cardTitle": "Update card",
  "action.payTitle": "Pay invoice",
  "action.loading": "Loading link…",
  "action.canceledBody": "Your subscription will end at the end of the current period.",
  "action.alreadyCanceledBody": "You do not need to request cancellation again.",
  "action.cardUpdatedBody": "Your subscription card has been updated. You can close this page.",
  "action.paidBody": "Your invoice has been updated. You can close this page.",
  "action.processingBody": "The charge has been confirmed and is awaiting settlement by the provider. Do not try to pay again.",
  "action.chargeAmount": "Charge amount",
  "action.plan": "Plan",
  "action.status": "Status",
  "action.invoice": "Invoice",
  "action.period": "Current period",
  "action.until": "until {{date}}",
  "action.authentication": "Your bank requested a security confirmation for your card.",
  "action.cancelButton": "Cancel at the end of the period",
  "action.saveButton": "Save card",
  "action.authenticateButton": "Authenticate card",
  "action.payButton": "Pay now",
  "action.trialing": "Trial",
  "action.active": "Active",
  "action.pastDue": "Past due",
  "action.canceled": "Canceled",
  "action.pending": "Pending",
  "action.processing": "Processing",
  "action.awaitingAction": "Awaiting action",
  "action.paid": "Paid",
  "action.inGrace": "Grace period",
  "action.failed": "Failed",
  'language.select': 'Language',
  'common.demo': 'Demo',
  'common.emailFallback': 'your email',
  'common.processing': 'Processing…',
  'common.free': 'free',
  'common.today': 'today',
  'common.total': 'Total',
  'common.unavailable': 'Unavailable',
  'common.onRequest': 'Contact us',
  'period.minute.one': 'minute',
  'period.minute.other': 'minutes',
  'period.day.one': 'day',
  'period.day.other': 'days',
  'period.week.one': 'week',
  'period.week.other': 'weeks',
  'period.month.one': 'month',
  'period.month.other': 'months',
  'period.year.one': 'year',
  'period.year.other': 'years',
  'period.single': '/{{unit}}',
  'period.every': ' every {{count}} {{unit}}',
  'period.for': 'For {{unit}}',
  'field.name': 'Full name',
  'field.namePlaceholder': 'As shown on your document',
  'field.email': 'Email',
  'field.emailPlaceholder': 'you@email.com',
  'field.phone': 'Phone / WhatsApp',
  'field.phonePlaceholder': '(00) 00000-0000',
  'field.internationalPhone': 'International phone (optional)',
  'field.internationalPhonePlaceholder': '+ country code and number',
  'field.document': 'CPF',
  'field.documentPlaceholder': '000.000.000-00',
  'pii.email': 'my email',
  'pii.phone': 'my phone number',
  'pii.emailPhone': 'my email and phone number',
  'pii.optional': 'Optional: does not affect your purchase',
  'pii.consent': 'I authorize the use of {{target}}, protected by hashing, to measure conversion from ads for this purchase.',
  'state.loading': 'Loading your checkout…',
  'state.notFoundTitle': 'Checkout unavailable',
  'state.notFoundBody': 'This checkout does not exist or is no longer active.',
  'state.errorTitle': 'Something went wrong',
  'state.errorBody': 'We could not load this checkout right now. Please try again shortly.',
  'error.payment': 'We could not complete the payment.',
  'error.businessTitle': 'Purchase unavailable',
  'error.paymentTitle': 'Payment not completed',
  'error.validationTitle': 'Check your information',
  'error.systemTitle': 'Something went wrong',
  'error.retry': 'Try again',
  'error.cardDetails': 'Check your card details.',
  'error.checkoutUnavailable': 'This checkout is currently unavailable for purchase.',
  'error.subscriptionCardOnly': 'Subscriptions can only be paid by card.',
  'error.emailWalletRequired': 'Enter your email to continue with the wallet.',
  'error.emailWalletInvalid': 'Enter a valid email to continue with the wallet.',
  'error.documentWalletInvalid': 'Enter a valid CPF to continue with the wallet.',
  'error.emailRequired': 'Enter your email to complete the purchase.',
  'error.emailInvalid': 'Enter a valid email to complete the purchase.',
  'error.documentInvalid': 'Enter a valid CPF to complete the purchase.',
  'error.confirmationExpired': 'The confirmation expired. Please try again.',
  'error.pixConfirmationExpired': 'The Pix confirmation expired. Try again or continue without this offer.',
  'error.pixOfferFailed': 'The offer Pix was not confirmed. Try again or continue without it.',
  'error.previousAttempt': '{{message}} Your previous attempt is still being reconciled; no new charge will be created.',
  'error.ambiguous': 'We could not confirm the payment yet. Try again; the same attempt will be reused safely.',
  'error.authentication': 'We could not complete card authentication.',
  'error.paymentAuthentication': 'We could not complete payment authentication.',
  'error.previousPending': 'The previous attempt has not been confirmed yet. Wait before trying again; no new charge was created.',
  'error.previousReconciling': 'The previous attempt is still being reconciled. Wait before trying again; no new charge was created.',
  'error.offerUnavailable': 'This offer is currently unavailable.',
  'error.offerProcessing': 'We could not process the offer.',
  'error.walletStart': 'We could not start the wallet payment.',
  'error.walletComplete': 'We could not complete the wallet payment.',
  'error.walletAuthentication': 'We could not complete authentication.',
  'error.walletProvider': 'We could not process the wallet payment. Try again or use another payment method.',
  'error.offerExternalPage': 'We could not open this offer securely. You can continue without it.',
  'error.offerComplete': 'We could not complete this offer. Try again or continue without it.',
  'error.invalidActionLink': 'This subscription link is invalid or incomplete.',
  'error.subscriptionActionLoad': 'We could not load this subscription action. Check the link and try again.',
  'error.subscriptionAction': 'We could not complete this subscription action. Try again shortly.',
  'error.subscriptionCardForm': 'We could not load the card form. Try again shortly.',
  'error.subscriptionAuthentication': 'We could not complete card authentication. Try again or use another card.',
  'block.PRICING_TOKEN_INVALIDO': 'Prices were updated. Review the checkout and try again.',
  'block.ASSINATURA_TRIAL_JA_UTILIZADO': 'This free trial has already been used for this product. You can still purchase the subscription without a trial.',
  'block.ASSINATURA_DUPLICADA': 'There is already an active or pending subscription for this product with this email.',
  'block.ASSINATURA_EM_ATRASO': 'There is an overdue subscription for this product. Settle the current subscription before purchasing again.',
  'block.PRODUTO_NAO_ACEITA_AFILIADOS': 'This product does not accept affiliate sales through this link.',
  'block.AFILIADO_CONFIGURACAO_FINANCEIRA_PENDENTE': 'This affiliate link is not ready to receive sales yet. Try without the affiliate link.',
  'block.AFILIADO_AUTO_COMPRA': 'Affiliate commission does not apply to the affiliate’s own purchase. Use the regular product link.',
  'block.ASSINATURA_SOMENTE_CARTAO': 'Subscriptions can only be paid by card.',
  'block.PLANO_INATIVO': 'This plan is not currently available for purchase.',
  'block.COTACAO_INDISPONIVEL': 'We could not update the exchange rate right now. Please try again shortly.',
  'block.PRODUTOR_CONFIGURACAO_FINANCEIRA_PENDENTE': 'This purchase is temporarily unavailable because the seller cannot receive payments for this product yet. Try again later or contact the seller.',
  'block.COPRODUTOR_CONFIGURACAO_FINANCEIRA_PENDENTE': 'This purchase is temporarily unavailable because the product payment setup is not ready yet. Try again later or contact the seller.',
  'block.COPRODUTOR_CONTA_STRIPE_INCOMPATIVEL': 'This purchase is temporarily unavailable because the product payment setup needs to be updated. Try again later or contact the seller.',
  'block.SEED_CONFIGURACAO_FINANCEIRA_PENDENTE': 'This purchase is temporarily unavailable right now. Try again later or contact the seller.',
  'block.SEED_CONTA_STRIPE_INCOMPATIVEL': 'This purchase is temporarily unavailable right now. Try again later or contact the seller.',
  'block.AFILIADO_CONTA_STRIPE_INCOMPATIVEL': 'This affiliate link is not ready to receive sales yet. Try without the affiliate link.',
  'block.CONFIGURACAO_FINANCEIRA_ALTERADA': 'The payment setup changed. Review the checkout and try again.',
  'block.PRODUTO_INATIVO': 'This product is no longer available for purchase.',
  'block.METODO_NAO_SUPORTADO_PARA_REGIME': 'This payment method is not available for this product. Choose another option.',
  'block.MOEDA_NAO_SUPORTADA_PARA_REGIME': 'This currency is not available for this checkout. Please try again later.',
  'block.METODO_NAO_PERMITIDO_PARA_PRODUTO': 'This payment method is not available for this product.',
  'block.PARCELAMENTO_NAO_PERMITIDO': 'Installments are not available for this product. Choose another payment option.',
  'block.CUPOM_INVALIDO': 'This coupon is invalid or expired.',
  'block.PRECO_ABAIXO_DO_MINIMO': 'This price is no longer available. Review the checkout and try again.',
  'block.ASSINATURA_TRIAL_GRATUITO_INDISPONIVEL': 'This free trial is no longer available. You can continue with the paid subscription.',
  'block.ASSINATURA_SEM_ORDER_BUMP': 'This subscription cannot be combined with the selected offer.',
  'block.ASSINATURA_SEM_CUPOM': 'This subscription does not accept coupons.',
  'block.FUNIL_INDISPONIVEL': 'The next offer is unavailable. You can continue without it.',
  'block.PAGAMENTO_SALVO_INDISPONIVEL': 'This saved payment method is no longer available. Choose another payment method.',
  'decline.insufficient_funds': 'Insufficient funds. Use another card or payment method.',
  'decline.expired_card': 'This card has expired. Check the expiry date or use another card.',
  'decline.incorrect_cvc': 'The card security code is incorrect. Check the CVC and try again.',
  'decline.invalid_cvc': 'The card security code is invalid. Check the CVC and try again.',
  'decline.incorrect_number': 'The card number is incorrect. Check the details and try again.',
  'decline.invalid_number': 'The card number is invalid. Check the details and try again.',
  'decline.card_velocity_exceeded': 'This card has reached its balance, credit, or per-purchase spending limit. Use another card or contact your bank.',
  'decline.authentication_required': 'Your bank requires authentication for this purchase. Try again and complete verification.',
  'decline.processing_error': 'We could not process the card right now. Please try again shortly.',
  'decline.issuer_not_available': 'The issuing bank is unavailable. Try again shortly or use another card.',
  'decline.try_again_later': 'The bank requested another attempt later. Wait a moment or use another card.',
  'decline.currency_not_supported': 'This card does not support the currency used for this purchase. Try another card or payment method.',
  'decline.card_not_supported': 'This card does not support this type of purchase. Use another card or contact your bank.',
  'decline.incorrect_address': 'The billing address is incorrect. Check the details and try again.',
  'decline.incorrect_zip': 'The billing postal code is incorrect. Check the details and try again.',
  'decline.invalid_expiry': 'The card expiration date is incorrect. Check the month and year and try again.',
  'decline.invalid_account': 'This card is not available for payment. Use another card or contact your bank.',
  'decline.invalid_amount': 'This amount is not allowed for payment with this card. Use another card or contact your bank.',
  'decline.duplicate_transaction': 'A purchase with the same details was submitted recently. Check whether the payment has already been confirmed before trying again.',
  'decline.contact_issuer': 'We could not authorize this purchase. Use another card or contact your bank.',
  'decline.testmode_decline': 'This test card cannot be used for this purchase. Use another card.',
  'decline.authentication_failure': 'We could not complete card authentication. Try again and complete the verification.',
  'decline.card_decline_rate_limit_exceeded': 'This card has had too many declined attempts. Wait 24 hours or use another card.',
  'decline.default': 'We could not complete the payment. Try another card or payment method.',
  'decline.subscriptionContext': 'We could not confirm your subscription. {{message}}',
  'decline.nonCard': 'The payment was not confirmed. Check the details and try again.',
  'payment.pix': 'Pix',
  'payment.boleto': 'Bank slip',
  'payment.card': 'Card',
  'payment.creditCard': 'Credit card',
  'payment.applePay': 'Apple Pay',
  'payment.googlePay': 'Google Pay',
  'payment.method': 'Payment method',
  'payment.express': 'Express checkout',
  'payment.otherMethods': 'Other payment methods',
  'payment.recurring': 'Recurring',
  'payment.upfront': 'One-time',
  'payment.instant': 'Instant',
  'payment.approved': 'Paid',
  'payment.pending': 'Awaiting confirmation',
  'payment.awaitingPix': 'Awaiting Pix confirmation',
  'payment.requiresAction': 'Awaiting authentication',
  'payment.notConfirmed': 'Not confirmed',
  'payment.firstChargePaid': 'First charge paid',
  'payment.freeTrialStarted': 'Free trial started',
  'payment.cardEnding': '{{brand}} ending in {{last4}}',
  'payment.processingWallet': 'Processing payment with {{wallet}}…',
  'payment.completeWallet': 'Complete payment in {{wallet}}',
  'payment.walletHelp': 'Use the secure window that is open. If you cancel, the card fields return automatically.',
  'payment.or': 'or',
  'payment.secureConnection': 'Payment data protected by a TLS connection',
  'payment.cardNumber': 'Card number',
  'payment.cardholderName': 'Name on card',
  'payment.cardholderPlaceholder': 'As shown on the card',
  'payment.expiry': 'Expiry date',
  'payment.cvv': 'CVV',
  'payment.boletoHelp': 'The bank slip is generated instantly and clears within 2 business days.',
  'payment.walletReceipt': 'Confirmation and receipt will be sent to {{email}}.',
  'payment.processedBy': 'Payment processed by VendePay and the payment provider. Data is handled according to the privacy policy.',
  'payment.subscriptionTrialNote': 'During the free period, we use a card to register the subscription without charging today. Apple Pay and Google Pay are available for purchases with an immediate charge.',
  'checkout.securePurchase': 'Secure purchase',
  'checkout.choosePlan': 'Choose your plan',
  'checkout.bestValue': 'Best value',
  'checkout.yourDetails': 'Your details',
  'checkout.guest': 'Buy without creating an account: you can create your password later.',
  'checkout.payment': 'Payment',
  'checkout.completeOrder': 'Complete your order',
  'checkout.orderSummary': 'Order summary',
  'checkout.reviewSummary': 'Purchase summary',
  'checkout.chargedNow': 'Charged now',
  'checkout.totalChargedNow': 'Total charged now',
  'checkout.awaitingConfirmation': 'Awaiting confirmation',
  'checkout.recurringCharges': 'Recurring charges',
  'checkout.nextCharges': 'Next charges',
  'checkout.subscriptionActive': 'Subscription active. The cancellation link is in the email.',
  'checkout.renewsFor': 'Renews automatically for {{value}}',
  'checkout.demoNotice': 'In demo mode, payment is simulated; with the API connected, the order is sent to the core.',
  'checkout.subscribeForToday': 'Subscribe for {{recurring}} · {{today}} today',
  'checkout.subscribeFor': 'Subscribe for {{value}}',
  'checkout.generateBoleto': 'Generate a bank slip for {{value}}',
  'checkout.payAndFinish': 'Pay {{value}} and complete purchase',
  'checkout.startTrial': 'Start {{days}}-day free trial',
  'checkout.startFree': 'Start free',
  'checkout.subscribeNow': 'Subscribe now',
  'checkout.payPix': 'Pay with Pix',
  'checkout.payNow': 'Pay now',
  'checkout.finishWallet': 'Complete in {{wallet}}',
  'checkout.productDelivery': 'The product will be delivered by the seller.',
  'checkout.confirmationSent': 'We sent confirmation to {{email}}. {{delivery}}',
  'checkout.guarantee': '{{days}}-day guarantee',
  'checkout.fullRefundGuarantee': '{{days}}-day guarantee: full refund',
  'checkout.secureEncrypted': 'Secure payment · encrypted data',
  'checkout.dataProtected': 'Data protected',
  'checkout.cardNotStored': 'We do not store your card',
  'coupon.percentDiscount': 'Percentage discount',
  'coupon.fixedDiscount': 'Fixed discount',
  "coupon.appliesToProduct": "Discount applied only to {{product}}.",
  "summary.purchaseItems": "Items in this purchase",
  "summary.purchaseTotal": "Total for this purchase",
  'coupon.beforeDiscount': 'Amount before coupon',
  'coupon.discountAmount': 'Discount applied',
  'coupon.afterDiscount': 'Amount after coupon',
  'coupon.label': 'Coupon {{code}}',
  'coupon.applied': 'Coupon applied',
  'coupon.remove': 'Remove',
  'coupon.code': 'Coupon code',
  'coupon.validating': 'Validating…',
  'coupon.apply': 'Apply',
  'coupon.haveOne': 'Have a coupon?',
  'coupon.notApplicable': 'Coupon does not apply to this amount.',
  'coupon.invalid': 'Invalid or expired coupon.',
  'coupon.error': 'We could not validate the coupon right now.',
  'summary.trialPeriod': 'Trial period',
  'summary.days': '{{days}} days',
  'summary.totalToday': 'Total today',
  'summary.recurringCharge': 'Recurring charge',
  'summary.pixUpfront': 'One-time with Pix: {{value}}',
  'pix.payToFinish': 'Pay with Pix to complete your purchase',
  'pix.scan': 'Scan the QR code or use the copy-and-paste code below.',
  'pix.copyPaste': 'Pix copy and paste',
  'pix.processingTitle': 'Awaiting confirmation',
  'pix.processingBody': 'Your payment is being processed. Once confirmed, we will send confirmation to {{email}}.',
  'pix.instantTitle': 'Pay with Pix and receive confirmation instantly',
  'pix.instantBody': 'Instant approval without leaving this page. The QR code appears after confirmation.',
  'pending.subscriptionTitle': 'Confirming your subscription',
  'pending.subscriptionBody': 'Authentication completed. We are activating your free period and will send confirmation to {{email}}.',
  'pending.authenticationTitle': 'Authentication required',
  'pending.authenticationBody': 'Your bank requested additional verification. Complete authentication to finish the payment.',
  'success.added': 'Added!',
  'success.addedBody': 'We charged +{{value}} to your card.',
  'success.subscriptionTitle': 'Subscription started!',
  'success.freeDays': 'You have {{days}} free days. Nothing was charged today.',
  'success.firstCharge': ' The first charge of {{value}} will be on {{date}}.',
  'success.subscriptionEmail': 'We sent confirmation and the cancellation link for the end of the period to {{email}}.',
  'success.paymentTitle': 'Payment approved!',
  'subscription.single': 'Subscription',
  'subscription.oneTime': 'One-time purchase',
  'subscription.bumpTrial': 'YES! Add {{title}}: {{days}} days free, then {{renewal}}',
  'subscription.bumpPaidTrial': 'YES! Add {{title}} for {{trial}} for the first {{days}} days, then {{renewal}}',
  'subscription.bumpOneTime': 'YES! Add {{title}} for only + {{value}}',
  'subscription.bumpRecurring': 'YES! Add {{title}} for only + {{value}}',
  'subscription.bumpTerms': 'Card subscription: renews automatically. You can cancel through the link sent by email.',
  'subscription.afterPaidTrialTerms': 'After the first {{days}} days, renews automatically for ',
  'subscription.freeTerms': '{{days}} days free, no charge today. Then ',
  'subscription.paidTrialTerms': 'Today {{value}} for the first {{days}} days, then ',
  'subscription.renewalTerms': 'Renews automatically: ',
  'subscription.cancelTerms': '. You can cancel at the end of the period using the link sent by email.',
  'upsell.downsellBadge': 'Wait! Special offer',
  'upsell.badge': 'Exclusive limited-time offer',
  'upsell.generatePix': 'Generate a Pix for {{value}}',
  'upsell.addCard': 'Yes, add +{{value}} to my card',
  'upsell.pixTitle': 'Pay with Pix to secure the offer',
  'upsell.pixBody': 'Scan the QR code or use the copy-and-paste code below. The offer is added after confirmation.',
  'upsell.continueWithout': 'Continue without this offer',
  'upsell.reassurance': 'Payment approved: before finishing, an exclusive offer',
  'upsell.trialDays': '{{days}} trial days',
  'upsell.pixSecure': 'Secure Pix for this offer',
  'upsell.pixOnlyOnConfirm': 'You only pay if you confirm the Pix',
  'upsell.oneClick': 'Secure one-click purchase',
  'upsell.noCardAgain': 'No need to enter your card again',
  'legacy.urgency': 'Limited-time offer', 'legacy.reassurance': 'Protected purchase · instant access after payment',
  'upsell.accept': 'Yes, I want it', 'upsell.reject': 'No, thank you',
  'installment.label': '{{count}}x of {{value}}',
} as const;

export type TranslationKey = keyof typeof en;
export type TranslationResource = Record<TranslationKey, string>;
